import burglaryIcon from '../../assets/coverageInfoModal/burglary.svg';
import civilLiabilityIcon from '../../assets/coverageInfoModal/civilLiability.svg';
import equipmentIcon from '../../assets/coverageInfoModal/equipment.svg';
import fixedElementsIcon from '../../assets/coverageInfoModal/fixedElements.svg';
import helpIcon from '../../assets/coverageInfoModal/help.svg';
import protectionIcon from '../../assets/coverageInfoModal/protection.svg';
import solidElementsBreakageIcon from '../../assets/coverageInfoModal/solidElementsBreakage.svg';
import specialistSupportIcon from '../../assets/coverageInfoModal/specialistSupport.svg';
import thiefProtectionIcon from '../../assets/coverageInfoModal/thiefProtection.svg';
import bikeSeatIcon from '../../assets/coverageInfoModal/bikeSeat.svg';
import groupIcon from '../../assets/coverageInfoModal/Group.svg';

export default {
  groupIcon,
  fixedElementsIcon,
  equipmentIcon,
  solidElementsBreakageIcon,
  burglaryIcon,
  civilLiabilityIcon,
  specialistSupportIcon,
  helpIcon,
  thiefProtectionIcon,
  protectionIcon,
  bikeSeatIcon,
};
